import { setTenant, useLocalStorageTenant } from "@/libs/auth";
import { useApiV1CorporationsSimplifyListQuery } from "@/services/api";
import { api } from "@/services/api";
import { useAppDispatch, useAppSelector } from "@/services/store";
import { Box, FormControl, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import React, { useEffect } from "react";

export const TenantSelector = () => {
  const { data: corporationsResponse, isLoading: corporationsAreLoading } = useApiV1CorporationsSimplifyListQuery();
  const tenantId = useAppSelector(state => state.auth.tenant?.id);
  const dispatch = useAppDispatch();
  const [selectedTenant, setSelectedTenant] = React.useState<string | null>(tenantId ?? null);
  const [_, setStoredTenant] = useLocalStorageTenant();

  useEffect(() => {
    setSelectedTenant(tenantId ?? null);
  }, [tenantId]);

  const handleChange = (event: SelectChangeEvent<typeof selectedTenant>) => {
    const {
      target: { value },
    } = event;
    const { id, name } = corporationsResponse?.find(({ id }) => id === value)!;
    const tenantBody = { id: id!, name };
    dispatch(setTenant(tenantBody));
    setStoredTenant(tenantBody);
    dispatch(api.util.resetApiState());
  };

  return (
    <Box sx={{ ml: "-31px" }}>
      {!corporationsAreLoading && (
        <FormControl sx={{ width: 200 }}>
          <Select
            data-testid="tenant-selector"
            labelId="demo-multiple-name-label"
            id="demo-multiple-name"
            value={selectedTenant ?? ""}
            sx={{
              ".MuiSvgIcon-root": { color: "var(--soft-black-gray-scale-50)" },
              color: "var(--soft-black-gray-scale-50)",
              fontSize: "16px",
              fontWeight: "600",
              lineHeight: "24px",
            }}
            onChange={handleChange}
          >
            {corporationsResponse?.map(({ id, name }) => (
              <MenuItem key={name} value={id}>
                {name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </Box>
  );
};
